import { render, staticRenderFns } from "./OkrOverviewTotalizer.vue?vue&type=template&id=73ec8a7b"
import script from "./OkrOverviewTotalizer.vue?vue&type=script&lang=js"
export * from "./OkrOverviewTotalizer.vue?vue&type=script&lang=js"
import style0 from "./OkrOverviewTotalizer.vue?vue&type=style&index=0&id=73ec8a7b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports